const keyHandler = (e) => handleKeyboard(e);
// create a container and set the full-size image as its background
function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', `${image.src}`);
  overlay = document.createElement('div');
  overlay.setAttribute("tabindex", "0");
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--color-aqua)';
}

function toggleLoadingSpinner(image) {
  const loadingSpinner = image.parentElement.parentElement.querySelector(`.loading__spinner`);
  loadingSpinner.classList.toggle('hidden');
}

function moveWithHover(image, event, zoomRatio) {
  // calculate mouse position
  const ratio = image.height / image.width;
  const container = event.target.getBoundingClientRect();
  const xPosition = event.clientX - container.left;
  const yPosition = event.clientY - container.top;
  const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
  const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

  // determine what to show in the frame
  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);
  overlay.onclick = () => removeOverlay(overlay);
  overlay.onmousemove = (event) => moveWithHover(image, event, zoomRatio);
  overlay.onmouseleave = () => removeOverlay(overlay);

  document.addEventListener("keydown", keyHandler, true);
}

function handleKeyboard(e) {
  const overlay = document.querySelector('.image-magnify-full-size');
  const jumpSize = 10;

  if (!overlay) return;

  const { x: currentX, y: currentY } = parseBackgroundPosition(overlay);
  let x = currentX, y = currentY;

  if (
    e.key == "ArrowUp" ||
    e.key == "ArrowDown" ||
    e.key == "ArrowLeft" ||
    e.key == "ArrowRight"
  ) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
  }
  
  
  switch(e.key) {
    case 'ArrowUp':
      y =  Math.max(0, parseInt(currentY) - jumpSize);
      break;
    case 'ArrowDown':
      y =  Math.min(100, parseInt(currentY) + jumpSize);
      break;
    case 'ArrowLeft':
      x =  Math.max(0, parseInt(currentX) - jumpSize);
      break;
    case 'ArrowRight':
      x =  Math.min(100, parseInt(currentX) + jumpSize);
      break;
    case 'Escape':
      removeOverlay(overlay);
      break;
  }
  overlay.style.backgroundPosition = `${x}% ${y}%`;
}
function removeOverlay(overlay) {
  overlay.remove();
  document.removeEventListener("keydown", keyHandler);
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover, .thumbnail-sr-zoom');
  const srButtons = document.querySelectorAll('.thumbnail-sr-zoom');
  images.forEach((image) => {
    image.onclick = (event) => {
      magnify(image, zoomRatio);
      moveWithHover(image, event, zoomRatio);
    };
  });

  srButtons.forEach(button => {
    button.onclick = (event) => {
      const image = button.parentElement.querySelector("img");
      magnify(image, zoomRatio);
    };
  });
}

enableZoomOnHover(2);


function parseBackgroundPosition(element) {
  const computedStyle = getComputedStyle(element);
  const bgPosition = computedStyle.backgroundPosition;
  const values = bgPosition.match(/[\d.-]+/g);
  
  if (values && values.length >= 2) {
    const x = parseFloat(values[0]);
    const y = parseFloat(values[1]);
    return { x, y };
  }
  
  if (values && values.length === 1) {
    const x = parseFloat(values[0]);
    return { x, y: 0 }; // Default y to 50% if only x is specified
  }
  
  return { x: 0, y: 0 };
}

